module.exports = __webpack_public_path__ + "static/media/3.8dfce1a3.jpg";